import { useCallback, useEffect } from 'react';
import ContentViewport from '../../components/ContentViewport';
import LessonCompleteInterstitial from '../../components/ContentInterstitials/LessonCompleteInterstitial';
import RecommendedLessons from '../../components/LessonPage/RecommendedLessons';
import UsageTracker from '../../utils/UsageTracker';
import { SCREENS, SUB_SCREENS } from '../../constants/Tracking';
import styled, { mediaQuery, css } from 'academy-common-lib/utils/Styling';
import { useRecommendationsForLesson } from '../../features/recommendations';
import { jsx as _jsx } from "react/jsx-runtime";
const MobilePadded = styled.div.withConfig({
  displayName: "RecommendedLessonsContainer__MobilePadded",
  componentId: "xm4m67-0"
})(["margin-top:24px;padding-left:12px;padding-right:12px;", ""], mediaQuery('notMobile', css(["padding-left:30px;padding-right:30px;"])));
export const MAX_RECOMMENDATIONS_FOR_LESSON_SIZE = 3;
const RecommendedLessonsContainer = ({
  lesson: {
    id: lessonId,
    name
  }
}) => {
  const {
    recommendationsForLesson,
    recommendationsForLessonError,
    recommendationsForLessonLoading
  } = useRecommendationsForLesson(lessonId);
  const hasError = !!recommendationsForLessonError;
  const recommendedLessonIds = recommendationsForLesson && recommendationsForLesson.recommendations.map(({
    recommendationId
  }) => recommendationId);
  useEffect(() => {
    UsageTracker.track('subpageView', {
      screen: SCREENS.LESSON,
      subscreen: SUB_SCREENS.RECOMMENDATIONS,
      lessonId
    });
  }, [lessonId]);
  const onClickRecommendedLesson = useCallback(recommendedLessonId => {
    UsageTracker.track('interaction', {
      action: 'click-recommendation',
      screen: SCREENS.LESSON,
      subscreen: SUB_SCREENS.RECOMMENDATIONS,
      recommendationSeedId: lessonId,
      recommendationType: 'LESSON',
      lessonId: recommendedLessonId
    });
  }, [lessonId]);
  if (hasError || !recommendationsForLessonLoading && (!recommendedLessonIds || !recommendedLessonIds.length)) {
    return /*#__PURE__*/_jsx(ContentViewport, {
      children: /*#__PURE__*/_jsx(LessonCompleteInterstitial, {})
    });
  }
  if (!recommendedLessonIds) return null;
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(MobilePadded, {
      "data-test-id": "track-recommendations-page",
      children: /*#__PURE__*/_jsx(ContentViewport, {
        children: /*#__PURE__*/_jsx(RecommendedLessons, {
          isRequesting: recommendationsForLessonLoading,
          lessonIds: recommendedLessonIds && recommendedLessonIds.slice(0, MAX_RECOMMENDATIONS_FOR_LESSON_SIZE),
          lessonName: name,
          onClickLesson: onClickRecommendedLesson
        })
      })
    })
  });
};
export default RecommendedLessonsContainer;